import { ImageStrapi as ImageStrapiTypes } from '@/cms/types/image';
import { env } from '@/constant/env';
import { apiEndpoints } from '@/constant/urls';
import { ImageStrapiProps } from '@/components/atoms/Image/ImageStrapi';
import { sendThirdPartySignUpEvent } from '@/integrations/trackingScripts/index';

type SsoLoginResponse = {
  url?: string;
};

export const getIsGoogleButton = (href: string) =>
  href.includes('https://accounts.google.com/o/oauth2');

const navigateAuthWindow = (authWindow: Window | null, url: string) => {
  if (authWindow) {
    authWindow.location.href = url;
  } else {
    window.location.href = url;
  }
};

export const handleHeroButtonLinkClick = async (
  e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  href: string,
  target: '_self' | '_blank' = '_blank'
) => {
  e.preventDefault();
  if (!getIsGoogleButton(href)) {
    if (target === '_blank') {
      return window.open(href, '_blank');
    } else {
      return (window.location.href = href);
    }
  }

  const origin = env.publicLocale === 'zh-cn' ? 'china' : 'global';

  const authWindow = window.open('about:blank', '_blank');

  sendThirdPartySignUpEvent(href, document.referrer, 'google');

  try {
    const ssoResponse = await fetch(
      `${apiEndpoints.ssoLogin}?sso_provider=google&origin=${origin}`,
      {
        method: 'GET',
        headers: { Accept: 'application/json' },
      }
    );

    if (!ssoResponse.ok) {
      throw new Error(`SSO login failed with status ${ssoResponse.status}`);
    }

    const data = (await ssoResponse.json()) as SsoLoginResponse;
    if (data.url) {
      navigateAuthWindow(authWindow, data.url);
    } else {
      authWindow?.close();
    }
  } catch (error) {
    console.error('Error opening Google SSO URL:', error);
    authWindow?.close();
  }
};

export function pullImagePropFromStrapiBlock(
  block: ImageStrapiProps,
  key: keyof ImageStrapiTypes
): ImageStrapiTypes[keyof ImageStrapiTypes] | '' {
  return block?.image?.data?.attributes?.[key] ?? '';
}
